<template>
  <div id="app">
    <Nav />
      <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import Nav from "./components/Nav.vue";
export default {
  name: "App",
  components: { Nav }
};
</script>

<style lang="css">
html,body {
  background-color: #0f1923;
  color: #f8f8f8;

}
#app {
  min-height: 95vh;
  }

a {
  text-decoration: none;
  font-weight: bold;
  color: white;
}
.uk-container {
  background-color: #0f1923;
  padding-bottom: 0 !important;
  padding-top: 25px;
}
.uk-section {
    padding-top: 0 !important;
  padding-bottom: 0 !important;
}
h1,h2,h3 {
  color: #ff4655;
  text-transform: uppercase;
  font-family: Staatliches;
}
h1 {
  font-size: 120px;
}
h2 {
  font-size: 60px;
}
h3 {
  font-size: 30px;
}

#category {
  font-family: Staatliches;
  font-weight: 500;
}

#title {
  letter-spacing: 0.4px;
  font-size: 22px;
  font-size: 1.375rem;
  line-height: 1.13636;
}

#banner {
  margin: 20px;
  height: 800px;
}

#editor {
  font-size: 16px;
  font-size: 1rem;
  line-height: 1.75;
}

.uk-navbar-container {
  background: #fff !important;
  font-family: Staatliches;
}

img:hover {
  -webkit-filter: grayscale(50%); /* Safari 6.0 - 9.0 */
  filter: grayscale(50%);
  transition: filter 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
}
</style>